import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncInviteePage = Load(
  () =>
    import(
      /* webpackChunkName: "withlocals-invitee" */ './components/InviteePage'
    ),
  {},
  true,
);

export const inviteeRoute: RouteDescriptor = {
  id: 'withlocals.invitee',
  path: `${basePath}/join/:bookingId/*`,
  label: 'Invitee',
  audience: 'both',
  layout: 'standalone',
  module: 'invite',
};

const InvitationRoutes = [
  <Route
    key={inviteeRoute.id}
    path={inviteeRoute.path}
    handle={createRouteHandle(inviteeRoute)}
    element={<AsyncInviteePage />}
  />,
];

export const inviteRouteDescriptors = [inviteeRoute];

export default InvitationRoutes;
